<template>
    <v-card
        elevation="2"
        outlined
        class="pa-5"
    >
        <v-card-title>Locator Assignment</v-card-title>       
        <v-data-table
            :headers="headers"
            :items="locatorData"
            item-key="account"
            class="row-pointer"
            @click:row="filterLocator"
        >
            <template v-slot:[`item.account`]="{item}">
                <span>{{ item.account }} : {{ titleCase(item.name) }}</span>
            </template>
            <template v-slot:[`item.count`]="{item}">
                <span>{{ item.count }}</span>
            </template>                   
        </v-data-table>
    </v-card>
</template>
<script>
import {setLocatorFilter}  from '../services/ticketTabs';
export default {
    props: {
        locatorData: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Locator',
                    value: 'account',
                    align: 'start',
                },
                {
                    text: 'Tickets',
                    value: 'count',
                    align: 'end',
                },                
            ],
        };
    },   
    methods: {
        filterLocator(item) {
            setLocatorFilter(item.uid);
        },
        titleCase(name) {
            if (!name) return '';
            if (typeof name !== 'string') return '';
            if (name.indexOf(' ') === -1) {
                return name.charAt(0).toUpperCase() + name.slice(1);
            }
            let str = name.toLowerCase().split(' ');
            for (let i = 0; i < str.length; i++) {
                str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1); 
            }
            return str.join(' ');
        },
               
    },
};
</script>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>